module.exports = __webpack_public_path__ + "img/faxing.6dfe8be6.png";